import React, {useEffect, useState} from 'react';
import {makeApiCall} from "../../Api/makeApiCall";
import {CalloutColors, CalloutSizes} from "react-foundation/lib/enums";
import {Callout} from "react-foundation";

export const SWEEP_INCOMING_FILES_DAG_ID = 'sweep_incoming_files'

const SweeperDagStatus = () => {

    const [dagStatus, setDagStatus] = useState(false);

    useEffect(() => {
        const url = `${process.env.REACT_APP_EDP_API_BASE_URL}/airflow/api/dags/${SWEEP_INCOMING_FILES_DAG_ID}`;
        makeApiCall(url)
            .then(result => setDagStatus(result?.is_paused || false))
            .catch(() => setDagStatus(false));
    }, []);

    return <div>
        {dagStatus ?<Callout
            size={CalloutSizes.SMALL}
            color={CalloutColors.WARNING}>
            <h5><i className="fa fa-exclamation-triangle"/> Sweeper is paused</h5>
        </Callout> : ''}
    </div>;
};

export default SweeperDagStatus;